// The patient form's screens, and the one rule for which of them may open.
//
// Four screens since the 2026-09-06 full-flow review (§2): the welcome page,
// the mandatory employer-form step and the separate Pay screen are gone —
// the scan is an optional card on Review, and Review carries the button.
// Pure: no React, no API. The Continue button, a refresh and the browser's
// back button all read the same rule here, so they can never disagree.

export const STEPS = [
  { key: 'personal' }, { key: 'employment' }, { key: 'leave' }, { key: 'review' },
];

export const REVIEW_STEP = STEPS.length - 1;

// Which steps the answers on file already satisfy.
export function stepComplete(form, s) {
  const unknown = (k) => (form.unknown_fields || []).includes(k);
  if (s === 0) return !!(form.full_name && form.dob);
  if (s === 1) return !!(form.employer_name && form.job_title && (form.employer_contact || form.employer_email || unknown('employer_contact')));
  if (s === 2) return !!(form.reason_for_leave && form.leave_start && (form.leave_end || unknown('leave_end')));
  return true;
}

// The furthest step these answers may open: the first incomplete one, or
// Review once the three question screens are done.
export function maxStep(form) {
  for (let s = 0; s < REVIEW_STEP; s++) if (!stepComplete(form, s)) return s;
  return REVIEW_STEP;
}

// Where to land on (re)load. A `?step=` from the URL wins when the answers
// support it (refresh, app-switch, back button — review §1.4); otherwise the
// first thing still to do. Review is the last step, so a returning patient
// always re-reads their answers before the one tap that sends them.
export function initialStep(form, urlStep) {
  const max = maxStep(form);
  if (Number.isInteger(urlStep) && urlStep >= 0) return Math.min(urlStep, max);
  return max;
}
